import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {CheckboxField, KTSVG} from 'helpers'
import {ColumnProps, IFormField} from 'models/Common'
import KTTable from 'helpers/ui-components/KTTable'
import {
 IReportingManager,
 IReportingManagerRes,
} from 'models/UserManagement'
import {
 fetchUserReportingOptions,
 submitUserReporting,
 fetchUserReporting,
} from 'utils/api/auth/userManagementService'
import {toast} from 'react-toastify'
import {KTUserLocation} from 'helpers/ui-components/KTUserLocation'
import {KTConfirmPopup} from 'helpers/ui-components/KTConfirmPopup'
// import {ILogin} from 'models/Auth'
type IProps = {
 accessDetails: IFormField | undefined
 userDetails?: IFormField | null
 userRole: number
 loggedInUserId: number | undefined
 setLoader: (newState: boolean) => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const HierarchyMapping = (props: IProps) => {
 const {t} = useTranslation()
 const [isDisabled, setIsDisabled] = useState(true)
 const [showAddNewBtn, setShowAddNewBtn] = useState(false)
 const [rmConfirmModalData, setRMConfirmModalData] =
  useState<IReportingManager | null>(null)
 const [tmConfirmModalData, setTMConfirmModalData] =
  useState<IReportingManager | null>(null)
 const [
  reportingManagerTableColList,
  setReportingManagerTableColList,
 ] = useState<Array<ColumnProps<IReportingManager>>>([])
 const [teamMemberTableColList, setTeamMemberTableColList] =
  useState<Array<ColumnProps<IReportingManager>>>([])
 const [teamMemberTableRows, setTeamMemberTableRows] =
  useState<IReportingManager[]>([])
 const [unAssignedTeamMember, setUnAssignedTeamMember] =
  useState<IReportingManager[]>([])
 const [
  unAssignedReportingManager,
  setUnAssignedReportingManager,
 ] = useState<IReportingManager[]>([])
 const [
  reportingManagerTableRows,
  setReportingManagerTableRows,
 ] = useState<IReportingManager[]>([])
 const {
  register,
  watch,
  handleSubmit,
  setValue,
  getValues,
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 const userId = props.userDetails?.id

 const handleDeleteReportingManager = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   props.setLoader(true)
   setValue('reportingManagerUserId', '')
   setReportingManagerTableRows([
    ...unAssignedReportingManager,
   ])
   setRMConfirmModalData(null)
   props.setLoader(false)
  } else {
   setRMConfirmModalData(null)
  }
 }

 const handleDeleteTeamMember = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   const record: IReportingManager | null =
    tmConfirmModalData
   if (record) {
    props.setLoader(true)
    const index = teamMemberTableRows.findIndex(
     (rec) => rec.id === record.id
    )
    if (index !== -1) {
     teamMemberTableRows[index].is_mapped = false
     const selectedIds = getValues('teamMemberUserIds')
     if (selectedIds && selectedIds.length > 0) {
      const indx = selectedIds.findIndex(
       (val: string) => val === record.id.toString()
      )
      if (indx !== -1) {
       selectedIds.splice(indx, 1)
       setValue('teamMemberUserIds', selectedIds)
      }
     }
     setTeamMemberTableRows([...teamMemberTableRows])
    }
    setTMConfirmModalData(null)
    props.setLoader(false)
   }
  } else {
   setTMConfirmModalData(null)
  }
 }

 const loadReporteeTableData = async () => {
  props.setLoader(true)
  setShowAddNewBtn(false)

  const selectedIds = getValues('teamMemberUserIds')
  const unAssigned = unAssignedTeamMember.filter(
   (val) => !selectedIds.includes(val.id.toString())
  )
  setTeamMemberTableRows([
   ...teamMemberTableRows,
   ...unAssigned,
  ])
  props.setLoader(false)
 }

 const renderReportingManagerTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IReportingManager>> = [
   {
    key: 'srNo',
    title: t(
     'userManagement.activate.reportingManagerMapping.srNo'
    ),
    className: 'w-[80px] text-center',
    isSrNo: true,
   },
   {
    key: 'full_name',
    title: t(
     'userManagement.activate.reportingManagerMapping.name'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.reportingManagerMapping.role'
    ),
    className: 'w-[130px]',
   },
   {
    key: 'location',
    title: t(
     'userManagement.activate.reportingManagerMapping.location'
    ),
    render: (_, record) => {
     return (
      <KTUserLocation location={record?.geo_mapping} />
     )
    },
   },
   {
    key: 'phone_number',
    title: t(
     'userManagement.activate.reportingManagerMapping.contact'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'status',
    title: t(
     'userManagement.activate.reportingManagerMapping.status'
    ),
    className: 'w-[80px]',
    render: (_, record) => {
     return record.is_active
      ? t(
         'userManagement.activate.reportingManagerMapping.active'
        )
      : t(
         'userManagement.activate.reportingManagerMapping.inActive'
        )
    },
   },
   ...(!isDisabled
    ? [
       {
        key: 'action',
        title: t(
         'userManagement.activate.reportingManagerMapping.action'
        ),
        className: '!text-center w-[140px]',
        render: (
         _: ColumnProps<IReportingManager>,
         record: IReportingManager
        ) => {
         return (
          <div
           key={record?.id}
           className='w-full flex justify-center items-center'
          >
           {record.is_mapped ? (
            <Button
             type='button'
             disabled={false}
             onClick={() => {
              void setRMConfirmModalData(record)
             }}
             color='green'
             className='text-center bg-white 
                      !rounded-lg text-[#CC293F] text-xs font-semibold border-none shadow-none'
            >
             <i
              className='fa fa-trash text-lg font-normal'
              aria-hidden='true'
             ></i>
             <span className='ml-2 pt-1'>
              {t('userManagement.activate.remove')}
             </span>
            </Button>
           ) : (
            <div
             className={`flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
         shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
            >
             <CheckboxField
              type='radio'
              disabled={false}
              label=''
              className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
              wrapperClassName=''
              value={record.id}
              name={`reportingManagerUserId`}
              id={`reportingManagerUserId-${record.id}`}
              register={register(`reportingManagerUserId`, {
               required: false,
              })}
             />
             <span
              className={`text-base font-semibold ml-1`}
             >
              {watch(`reportingManagerUserId`) ===
              record.id.toString()
               ? t(
                  'userManagement.activate.reportingManagerMapping.added'
                 )
               : t(
                  'userManagement.activate.reportingManagerMapping.add'
                 )}
             </span>
            </div>
           )}
          </div>
         )
        },
       },
      ]
    : []),
  ]
  setReportingManagerTableColList(columns)
  props.setLoader(false)
 }

 const renderTeamMemberTableData = async () => {
  props.setLoader(true)

  const columns: Array<ColumnProps<IReportingManager>> = [
   {
    key: 'srNo',
    title: t(
     'userManagement.activate.teamMemberMapping.srNo'
    ),
    className: 'w-[80px] text-center',
    isSrNo: true,
   },
   {
    key: 'full_name',
    title: t(
     'userManagement.activate.teamMemberMapping.name'
    ),
   },
   {
    key: 'category',
    title: t(
     'userManagement.activate.teamMemberMapping.role'
    ),
    className: 'w-[130px]',
   },
   {
    key: 'phone_number',
    title: t(
     'userManagement.activate.teamMemberMapping.contact'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'currentlyReportingTo',
    title: t(
     'userManagement.activate.teamMemberMapping.currentlyReportingTo'
    ),
    className: 'w-[100px]',
   },
   {
    key: 'status',
    title: t(
     'userManagement.activate.teamMemberMapping.status'
    ),
    className: 'w-[80px]',
    render: (_, record) => {
     return record.is_active
      ? t(
         'userManagement.activate.teamMemberMapping.active'
        )
      : t(
         'userManagement.activate.teamMemberMapping.inActive'
        )
    },
   },
   ...(!isDisabled
    ? [
       {
        key: 'action',
        title: t(
         'userManagement.activate.teamMemberMapping.action'
        ),
        className: '!text-center w-[140px]',
        render: (
         _: ColumnProps<IReportingManager>,
         record: IReportingManager
        ) => {
         return (
          <div
           key={record?.id}
           className='w-full flex justify-center items-center'
          >
           {record.is_mapped ? (
            <Button
             type='button'
             disabled={false}
             onClick={() => {
              void setRMConfirmModalData(record)
             }}
             color='green'
             className='text-center bg-white 
                      !rounded-lg text-[#CC293F] text-xs font-semibold border-none shadow-none'
            >
             <i
              className='fa fa-trash text-lg font-normal'
              aria-hidden='true'
             ></i>
             <span className='ml-2 pt-1'>
              {t('userManagement.activate.remove')}
             </span>
            </Button>
           ) : (
            <div
             className={`flex justify-center items-center w-[118px] h-12 rounded-lg border border-[#4E83E4] cursor-pointer text-[#4E83E4] font-semibold text-center
    shadow-[0_4px_4px_0_rgba(0, 0, 0, 0.12)] bg-white px-1 py-[3px]`}
            >
             <CheckboxField
              type='checkbox'
              disabled={false}
              label=''
              className={`activate-user-checkbox w-5 h-5 mt-1 text-blue-600 bg-gray-100 rounded border-gray-300 border-neutral-30`}
              wrapperClassName=''
              value={record.id}
              name={`teamMemberUserIds`}
              id={`teamMemberUserIds-${record.id}`}
              register={register(`teamMemberUserIds`, {
               required: false,
              })}
             />
             <span
              className={`text-base font-semibold ml-1`}
             >
              {watch(`teamMemberUserIds`)?.length > 0 &&
              watch(`teamMemberUserIds`).includes(
               record.id.toString()
              )
               ? t(
                  'userManagement.activate.teamMemberMapping.added'
                 )
               : t(
                  'userManagement.activate.teamMemberMapping.add'
                 )}
             </span>
            </div>
           )}
          </div>
         )
        },
       },
      ]
    : []),
  ]
  setTeamMemberTableColList(columns)
  props.setLoader(false)
 }

 const getReportingManager = async () => {
  props.setLoader(true)
  const res: IReportingManagerRes =
   await fetchUserReportingOptions(Number(userId))
  if (res?.reporting_managers) {
   setUnAssignedReportingManager(res?.reporting_managers)
  }
  if (res?.reportees) {
   setUnAssignedTeamMember(res?.reportees)
  }
  props.setLoader(false)
  return res
 }

 const getUserReporting = async () => {
  const reportingRes: IReportingManagerRes =
   await getReportingManager()
  props.setLoader(true)
  const res: IFormField | null = await fetchUserReporting(
   Number(userId)
  )
  if (res?.managers) {
   const managers: IReportingManager[] = res.managers.map(
    (val: IReportingManager) => {
     return {
      ...val,
      is_mapped: true,
     }
    }
   )
   if (managers.length > 0) {
    setValue(
     'reportingManagerUserId',
     managers[0]?.id.toString()
    )
    setReportingManagerTableRows(managers)
   } else {
    setReportingManagerTableRows(
     reportingRes?.reporting_managers ?? []
    )
   }
  }
  const assigendForOwn: string[] = []
  if (res?.reportees) {
   const reportees: IReportingManager[] = res.reportees.map(
    (val: IReportingManager) => {
     assigendForOwn.push(val.id.toString())
     return {
      ...val,
      is_mapped: true,
     }
    }
   )
   setValue('teamMemberUserIds', assigendForOwn)
   setTeamMemberTableRows(reportees)
  }
  setShowAddNewBtn(true)
  props.setLoader(false)
 }

 async function submitFormData(formData: IFormField) {
  let res
  props.setLoader(true)
  const reporteeIds = formData?.teamMemberUserIds
   ? Array.isArray(formData.teamMemberUserIds)
     ? formData.teamMemberUserIds
     : [formData.teamMemberUserIds]
   : []
  const payloadManager = {
   reportee_ids: [userId],
   manager_id: formData.reportingManagerUserId ?? '',
  }
  res = await submitUserReporting(payloadManager)
  const payloadReportee = {
   reportee_ids: reporteeIds.length > 0 ? reporteeIds : [],
   manager_id: userId,
  }
  res = await submitUserReporting(payloadReportee)

  if (res) {
   toast.success(res)
  }
  props.setLoader(false)
 }

 const handleEditBtnClick = () => {
  if (props.accessDetails?.activationFlow?.canEdit) {
   setIsDisabled(false)
  }
 }

 useEffect(() => {
  void getUserReporting()
 }, [])

 useEffect(() => {
  void renderReportingManagerTableData()
 }, [reportingManagerTableRows, isDisabled])

 useEffect(() => {
  void renderTeamMemberTableData()
 }, [teamMemberTableRows, isDisabled])

 return (
  <>
   {rmConfirmModalData && (
    <KTConfirmPopup
     showConfirmModel={rmConfirmModalData ? true : false}
     handleConfirmBtnClick={handleDeleteReportingManager}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.deleteConfirmModalSubTitle')} ${
      rmConfirmModalData.full_name
     }?`}
    />
   )}

   {tmConfirmModalData && (
    <KTConfirmPopup
     showConfirmModel={tmConfirmModalData ? true : false}
     handleConfirmBtnClick={handleDeleteTeamMember}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.deleteConfirmModalSubTitle')} ${
      tmConfirmModalData.full_name
     }?`}
    />
   )}
   <div className='w-full'>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='text-[#171B1F] flex justify-between text-lg font-normal'>
      <div>
       {t('userManagement.activate.hierarchyMapping.title')}
      </div>
      {props.accessDetails?.activationFlow?.canEdit &&
       (isDisabled ? (
        <Button
         key={'edit'}
         type='button'
         disabled={false}
         onClick={handleEditBtnClick}
         color='blue'
         className='text-center py-[9px] px-6 hover:bg-[#4E83E4] w-[85px]
                              !rounded-lg text-base text-[#4E83E4] hover:text-white font-semibold border-[#4E83E4]'
        >
         {t('common.edit')}
        </Button>
       ) : reportingManagerTableRows?.length >= 0 ||
         teamMemberTableRows?.length >= 0 ? (
        <Button
         key={'save'}
         type='submit'
         disabled={false}
         color='blue'
         className='text-center py-[9px] px-6 bg-[#4E83E4] 
                              !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
        >
         {t('common.save')}
        </Button>
       ) : (
        <></>
       ))}
     </div>

     <div className='text-[#171B1F] text-lg font-normal mt-6'>
      {t(
       'userManagement.activate.reportingManagerMapping.title'
      )}
     </div>
     <div className='w-full mt-6'>
      <KTTable
       data={reportingManagerTableRows}
       columns={reportingManagerTableColList}
       headerClass='bg-[#80868C]'
       headerColClass='!border-0 text-left'
       colClass='text-[#33393D] !text-sm font-normal !border-0'
       tableClass=''
       rowClass='even:bg-[#E6EBF0]'
       showPagination={false}
      />
     </div>
     <div className='w-full mt-10'>
      <div className='text-[#171B1F] text-lg font-normal'>
       {t(
        'userManagement.activate.teamMemberMapping.title'
       )}
      </div>
      <div className='w-full mt-6'>
       <KTTable
        data={teamMemberTableRows}
        columns={teamMemberTableColList}
        headerClass='bg-[#80868C]'
        headerColClass='!border-0 text-left'
        colClass='text-[#33393D] !text-sm font-normal !border-0'
        tableClass=''
        rowClass='even:bg-[#E6EBF0]'
        showPagination={false}
       />
       {!isDisabled && showAddNewBtn && (
        <div className='border-[#E6EBF0] border-[0.5px] py-3 px-4 flex items-center w-full'>
         <div
          className='flex text-[#4E83E4] text-base font-medium items-center cursor-pointer'
          onClick={() => {
           void loadReporteeTableData()
          }}
         >
          <KTSVG
           path={`/media/icons/plus.svg`}
           svgClassName={`w-5 h-5`}
          />
          <div>
           {t('common.addNew') + ' '}
           {t(
            'userManagement.activate.teamMemberMapping.title'
           )}
          </div>
         </div>
        </div>
       )}
      </div>
     </div>
    </form>
   </div>
  </>
 )
}

export default HierarchyMapping
